<template>
  <div class="register_merchant" :class="{ isiOSX1: isiOSX, notApp: notApp }">
    <van-nav-bar
      title="开通商家"
      :fixed="true"
      left-arrow
      @click-left="goBack"
      :class="{ isiOSX: isiOSX }"
    />
    <div class="box">
      <div class="content">
        <p class="tip" v-show="step != 1">验证码已发送至{{ phone }}</p>
        <van-row class="user-links">
          <van-cell-group v-show="step == 1">
            <van-field
              class="mobile"
              v-model="phone"
              label="会员手机号"
              placeholder="输入您的手机号"
              type="number"
              onkeyup="this.value=this.value.replace(/\D/g,'')"
              onafterpaste="this.value=this.value.replace(/\D/g,'')"
              maxlength="12"
            />
            <van-button class="submit" size="large" @click="next"
              >下一步</van-button
            >
          </van-cell-group>
          <van-cell-group v-show="step == 2">
            <van-field
              class="varify"
              v-model="code"
              label="验证码"
              placeholder="请输入验证码"
              type="number"
              onkeyup="this.value=this.value.replace(/\D/g,'')"
              onafterpaste="this.value=this.value.replace(/\D/g,'')"
            >
              <van-button
                slot="button"
                size="small"
                @click="getvarify"
                v-if="downcounttime == 0"
                >重新获取</van-button
              >
              <van-button
                class="downcount"
                slot="button"
                size="small"
                v-if="downcounttime == 1"
                >{{ down }}s后重新获取</van-button
              >
            </van-field>
            <van-button class="submit" size="large" @click="register"
              >提交</van-button
            >
          </van-cell-group>
          <van-cell-group class="merchant" v-show="step == 3">
            <van-field
              class="varify1"
              v-model="code"
              label="验证码"
              placeholder="请输入验证码"
              type="number"
              onkeyup="this.value=this.value.replace(/\D/g,'')"
              onafterpaste="this.value=this.value.replace(/\D/g,'')"
            >
              <van-button
                slot="button"
                size="small"
                @click="getvarify"
                v-if="downcounttime == 0"
                >重新获取</van-button
              >
              <van-button
                class="downcount"
                slot="button"
                size="small"
                v-if="downcounttime == 1"
                >{{ down }}s后重新获取</van-button
              >
            </van-field>
            <van-field
              v-model="password"
              label="登录密码"
              type="password"
              placeholder="请设置登录密码"
              onkeyup="value=value.replace(/[^\w]/ig,'')"
              onafterpaste="this.value=this.value.replace(/[^\w]/ig,'')"
              maxlength="20"
            />
            <van-field
              v-model="repassword"
              label="确认密码"
              type="password"
              placeholder="请再次输登录密码"
              onkeyup="value=value.replace(/[^\w]/ig,'')"
              onafterpaste="this.value=this.value.replace(/[^\w]/ig,'')"
              maxlength="20"
            />
            <van-button class="submit" size="large" @click="register"
              >提交</van-button
            >
          </van-cell-group>
        </van-row>
      </div>
    </div>
    <van-overlay :show="showTip">
      <div class="wrapper">
        <div class="block">
          <p class="title">温馨提示</p>
          <p class="tip">
            您已完成销巴会员和商户账号的注册，可直接去商户app登录进行业务的开通。
          </p>
          <van-button class="left" @click="closeTipPupop">取消</van-button>
          <van-button class="right" @click="goMerchant"
            >立即前往</van-button
          >
        </div>
      </div>
    </van-overlay>
  </div>
</template>
<script>
export default {
  data() {
    return {
      showTip: false,
      isiOSX: false,
      phone: "",
      code: "",
      password: "",
      repassword: "",
      downcounttime: 1,
      down: 60,
      step: 1,
      getVerifyNum: 0,
      stopGet: "",
      flag: 0,
      notApp: false,
    };
  },
  created() {
    this.isiOSX = this.isIphoneX();
    // this.notApp = !this.$route.query.isApp;
  },
  mounted() {
    document.documentElement.style.setProperty(
      "font-size",
      (document.body.clientWidth / 375) * 10 + "px"
    );
    setTimeout(() => {
      document.querySelector(".mobile input").focus();
    }, 500);
  },
  methods: {
    closeTipPupop() {
      this.showTip = false;
      this.goBack();
    },
    // downLoad() {
    //   this.params("", "", "downLoad");
    // },
    // goMerchantApp() {
    //   var u = navigator.userAgent;
    //   //var isWeixin = u.toLowerCase().indexOf('micromessenger') !== -1; // 微信内
    //   var isAndroid = u.indexOf("Android") > -1 || u.indexOf("Linux") > -1; //android终端
    //   var isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
    //   //ios和安卓app的scheme协议
    //   window.location.href = "XBMerchant://";
    //   setTimeout(function () {
    //     let hidden =
    //       window.document.hidden ||
    //       window.document.mozHidden ||
    //       window.document.msHidden ||
    //       window.document.webkitHidden;
    //     if (typeof hidden == "undefined" || hidden == false) {
    //       if (isAndroid) {
    //         //android端
    //         window.location.href =
    //           "http://a.app.qq.com/o/simple.jsp?pkgname=com.shallbuy.lifestore";
    //       } else if (isIOS) {
    //         //ios端
    //         window.location.href =
    //           "https://itunes.apple.com/us/app/id1398621785?ls=1&mt=8";
    //       }
    //     }
    //   }, 2000);
    // },
    goMerchant(){
      var u = navigator.userAgent;
      var isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
      if(isIOS){
        this.goBack();
      }else{
        this.params(JSON.stringify({"minitype":"store"}),JSON.stringify({"minitype":"store"}),'openMiniProgram')
      }
    },
    goBack() {
      this.params("", "", "goBack");
    },
    next() {
      this.verigyPhone();
      this.$api
        .post("/member-relation/index/check/member/join/recommend", {
          phone: this.phone,
          share_code: this.$route.query.shareCode,
        })
        .then((res) => {
          if (res.id) {
            this.step = 2;
            setTimeout(() => {
              document.querySelector(".varify input").focus();
            }, 500);
          } else {
            this.step = 3;
            setTimeout(() => {
              document.querySelector(".varify1 input").focus();
            }, 500);
          }
          this.getvarify();
        })
        .catch((err) => {
          let keys = Object.keys(err);
          let key = keys[0];
          let message = err.message || err[key][0];
          if (message.slice(0, 10) == "timeout of") {
            this.$toast("网络不给力，请稍候重试");
          } else {
            this.$toast(message);
          }
        });
    },
    getvarify() {
      if (this.getVerifyNum < 5) {
        this.getVerifyNum++;
        this.verigyPhone();
        const _this = this;
        this.$api
          .post("/pushmsg/index/sms/send-code", {
            mobile: this.phone,
            type: this.step == 3 ? 0 : 38,
          })
          .then((res) => {
            _this.down = 60;
            const timer = setInterval(function () {
              _this.down--;
              _this.downcounttime = 1;
              if (_this.down <= 0) {
                clearInterval(timer);
                _this.downcounttime = 0;
              }
            }, 1000);
            _this.$toast("验证码已发送，请注意查收");
          })
          .catch((err) => {
            let keys = Object.keys(err);
            let key = keys[0];
            let message = err.message || err[key][0];
            if (message.slice(0, 10) == "timeout of") {
              this.$toast("网络不给力，请稍候重试");
            } else {
              this.$toast(message);
            }
          });
      } else {
        var current = Math.floor(new Date().getTime() / 1000);
        var tip = "";
        if (this.getVerifyNum == 5) {
          this.getVerifyNum++;
          this.stopGet = current + 60 * 15;
        }
        var ts = this.stopGet - current;
        var mm = Math.floor(ts / 60);
        var ss = ts - mm * 60;
        if (mm && ss) {
          tip =
            "获取验证码次数已超过5次，请过" + mm + "分钟" + ss + "秒之后再试。";
        } else if (mm && !ss) {
          tip = "获取验证码次数已超过5次，请过" + mm + "分钟之后再试。";
        } else if (!mm && ss) {
          tip = "获取验证码次数已超过5次，请过" + ss + "秒之后再试。";
        }
        this.$toast(tip);
      }
    },
    register() {
      this.verigyPhone();
      if (!this.code) {
        this.$toast("请输入验证码");
        return false;
      }
      if (this.step == 2 && this.flag == 0) {
        this.flag = 1;
        this.submit();
        return false;
      }
      if (!this.password) {
        this.$toast("请输入密码");
        return false;
      } else if (
        /(?!^\d+$)(?!^[A-Za-z]+$)(?!^[^A-Za-z0-9]+$)^\S{6,20}$/.test(
          this.password
        )
      ) {
        //密码格式正确 下一步验证 两次输入密码是否一致
        if (this.password == this.repassword) {
          //两次输入密码一致 下一步请求接口
          if (this.flag == 0) {
            this.flag = 1;
            this.submit();
          }
        } else if (!this.repassword) {
          this.$toast("请输入确认密码");
          return false;
        } else {
          this.$toast("两次输入的密码不一致");
          return false;
        }
      } else {
        this.$toast("密码格式错误");
        return false;
      }
    },
    submit() {
      let registerUrl = "";
      let parm = {};
      if (this.step == 2) {
        registerUrl = "/member-relation/index/old/member/join/recommend";
        parm = {
          phone: this.phone,
          code: this.code,
          share_code: this.$route.query.shareCode,
        };
      } else {
        registerUrl = "member/index/member/h5/register";
        parm = {
          username: this.phone,
          code: this.code,
          share_code: this.$route.query.shareCode,
          password: this.password,
          password_confirmation: this.repassword,
        };
      }
      this.$api
        .post(registerUrl, parm)
        .then((res) => {
          if (this.step == 2) {
            this.showTip = true;
          } else {
            this.newMemberJoin();
          }
        })
        .catch((err) => {
          this.flag = 0;
          let keys = Object.keys(err);
          let key = keys[0];
          let message = err.message || err[key][0];
          if (message.slice(0, 10) == "timeout of") {
            this.$toast("网络不给力，请稍候重试");
          } else {
            this.$toast(message);
          }
        });
    },
    newMemberJoin() {
      this.$api
        .post("/member-relation/index/new/member/join/recommend", {
          phone: this.phone,
          share_code: this.$route.query.shareCode,
        })
        .then((res) => {
          this.showTip = true;
        })
        .catch((err) => {
          let keys = Object.keys(err);
          let key = keys[0];
          let message = err.message || err[key][0];
          if (message.slice(0, 10) == "timeout of") {
            this.$toast("网络不给力，请稍候重试");
          } else {
            this.$toast(message);
          }
        });
    },
    verigyPhone() {
      if (this.phone == "") {
        this.$toast("请输入手机号");
        return false;
      } else if (/^1\d{10}$/.test(this.phone)) {
        // return true;
      } else {
        this.$toast("手机号格式错误");
        return false;
      }
    },
  },
};
</script>
<style>
html {
  font-size: calc(var(--sizeScale2) * 10px);
}
.van-field__button {
  padding: 0;
}
.van-field__label {
  color: #333;
  font-size: 1.7rem;
  font-weight: bold;
}
.van-field__control {
  color: #333;
  font-size: 1.7rem;
}
input::-webkit-input-placeholder {
  /* WebKit, Blink, Edge */
  color: #ccc !important;
}
input:-moz-placeholder {
  /* Mozilla Firefox 4 to 18 */
  color: #ccc !important;
}
input::-moz-placeholder {
  /* Mozilla Firefox 19+ */
  color: #ccc !important;
}
input:-ms-input-placeholder {
  /* Internet Explorer 10-11 */
  color: #ccc !important;
}
.mobile .van-field__label {
  width: 9.7rem;
}
.varify .van-field__label {
  width: 6.8rem;
}
.merchant .van-field__label {
  width: 9.4rem;
}
</style>
<style lang="less" scoped>
.register_merchant {
  min-height: 100%;
  box-sizing: border-box;
  background: #f9591b;
  padding-top: 72px;
  /deep/.van-nav-bar {
    height: 44px;
    line-height: 44px;
    padding-top: 28px;
    border: none;
    box-shadow: none;
    background: #f9591b;
    overflow: hidden;
    .van-nav-bar__title {
      color: #ffffff;
      font-size: 1.8rem;
      font-weight: 400;
    }
    .van-nav-bar__text {
      color: #ffffff;
      font-size: 1.6rem;
      font-weight: 400;
      padding: 0 1.2rem;
    }
    .van-icon {
      color: #ffffff;
    }
  }
  .van-hairline--bottom:after {
    border-bottom-width: 0px !important;
  }
  .isiOSX {
    padding-top: 44px;
  }
  .box {
    padding: 0.7rem 1.8rem 0;
    .content {
      height: auto;
      border-radius: 0.8rem;
      padding: 1.8rem 1.5rem 2.4rem;
      box-sizing: border-box;
      background: #fff;
      .tip {
        color: #999;
        font-size: 1.3rem;
        height: 2.1rem;
        line-height: 2.1rem;
        margin-bottom: 0.6rem;
      }
      .van-hairline--top-bottom::after {
        border-width: 0 0;
      }
      .van-cell-group {
        .van-cell {
          padding: 1.4rem 0;
          // margin-top: 1.4rem;
          background: rgba(255, 255, 255, 0);
          .van-button {
            color: #f9591b;
            border: none;
            font-size: 1.7rem;
            height: 2.2rem;
            line-height: 2.2rem;
            padding-left: 2rem;
            padding-right: 0;
            font-weight: bold;
            border-left: solid 1px #eee;
          }
          .downcount {
            color: #ccc;
            padding-left: 1.1rem;
          }
        }
        .submit {
          color: #fff;
          font-size: 1.6rem;
          height: 4.2rem;
          line-height: 4.2rem;
          border: none;
          border-radius: 2.1rem;
          margin-top: 1.5rem;
          background: -webkit-linear-gradient(
            to right,
            #fc740c,
            #f41a3c
          ); /* Safari 5.1 - 6.0 */
          background: -o-linear-gradient(
            to right,
            #fc740c,
            #f41a3c
          ); /* Opera 11.1 - 12.0 */
          background: -moz-linear-gradient(
            to right,
            #fc740c,
            #f41a3c
          ); /* Firefox 3.6 - 15 */
          background: linear-gradient(to right, #fc740c, #f41a3c);
        }
        .van-cell::after {
          content: " ";
          position: absolute;
          pointer-events: none;
          -webkit-box-sizing: border-box;
          box-sizing: border-box;
          left: 0px;
          right: 0;
          bottom: 0;
          /*-webkit-transform: scaleY(0.5);
	        transform: scaleY(0.5);*/
          border-bottom: 1px solid #ebedf0;
        }
      }
    }
  }
  .wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    .block {
      width: 29.6rem;
      height: 22.3rem;
      border-radius: 1.2rem;
      padding: 2.4rem 3.6rem;
      background-color: #fff;
      box-sizing: border-box;
      color: #333;
      text-align: center;
      .title {
        font-size: 1.7rem;
        height: 2.8rem;
        line-height: 2.8rem;
        margin-bottom: 1.5rem;
        font-weight: bold;
      }
      .tip {
        font-size: 1.5rem;
        height: 7.2rem;
        line-height: 2.4rem;
        margin-bottom: 2.4rem;
        text-align: left;
      }
      .van-button {
        width: 9.4rem;
        height: 3.6rem;
        line-height: 3.6rem;
        border-radius: 1.8rem;
        text-align: center;
        box-sizing: border-box;
        float: left;
        padding: 0;
        display: inline-block;
      }
      .left {
        color: #666;
        font-size: 1.6rem;
        background: #fff;
        border: solid 0.05rem #eee;
      }
      .right {
        color: #fff;
        font-size: 1.6rem;
        float: right;
        border: none;
        background: -webkit-linear-gradient(
          to right,
          #fc740c,
          #f41a3c
        ); /* Safari 5.1 - 6.0 */
        background: -o-linear-gradient(
          to right,
          #fc740c,
          #f41a3c
        ); /* Opera 11.1 - 12.0 */
        background: -moz-linear-gradient(
          to right,
          #fc740c,
          #f41a3c
        ); /* Firefox 3.6 - 15 */
        background: linear-gradient(
          to right,
          #fc740c,
          #f41a3c
        ); /* 标准的语法（必须放在最后） */
      }
    }
  }
}
.isiOSX1 {
  padding-top: 88px;
}
.notApp {
  padding-top: 0;
  .van-nav-bar {
    display: none;
  }
}
</style>


